var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCollege = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.749 13.747a.634.634 0 0 0 .485 0l8.84-3.29v7.592c.226-.049.452-.097.695-.097.242 0 .469.032.695.097V9.927l.986-.354c.598-.224.598-1.075 0-1.3L15.217 4.1a.634.634 0 0 0-.484 0L3.5 8.273c-.598.225-.598 1.076 0 1.3l11.249 4.174z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.833 19.604c-1.185 0-2.082 1.533-2.082 3.56v1.434c0 .395.304.708.688.708h2.77a.694.694 0 0 0 .689-.708v-1.434c.016-2.027-.88-3.56-2.065-3.56z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.293 12.865-6.572 2.355a2.214 2.214 0 0 1-1.487 0l-6.572-2.355c-.589 2.058-.441 3.415-.458 3.836 0 .484.507.811.965.624.016 0 1.667-.624 3.27-.624 1.487 0 3.073 1.186 3.089 1.201a.74.74 0 0 0 .883 0c.441-.327 1.847-1.2 3.09-1.2 1.602 0 3.253.623 3.27.623.457.172.964-.156.964-.624 0-.405.147-1.778-.442-3.836z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCollege);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-college.c32ca86230ded96eef175cdee8159959.svg";